import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const NubeiPayment = () => {
  return <CommonProcess />;
};

export default NubeiPayment;
